require('./mortgageRequestNoCoHolderMessage.scss');
// @ vendors
const React = require('react');
// @ commons
const { formatText } = require('core/i18n').i18n;
const { ContentBox } = require('commonsComponents/contentBox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

const MortgageRequestNoCoHolderMessage = () => {

    return (
        <ContentBox className="mortgage-request-no-coholder-message">
            <div className="clearfix">
                <OKMessage
                    title={formatText('mortgageRequestNoCoHolderMessage-title')}
                    type="informative"
                >
                    {formatText('mortgageRequestNoCoHolderMessage-description')}
                </OKMessage>
                <hr />
                <OKLink modifier="emphasize" to="/myprofile/mortgage/panel">
                    {formatText('mortgageRequestCommons-returnText')}
                </OKLink>
            </div>
        </ContentBox>
    );
};

module.exports = MortgageRequestNoCoHolderMessage;
